import NotificationCounter from './NotificationCounter';

export default NotificationCounter;
